import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetCustomService } from 'hooks/rest/useGetCustomService';

interface SecurityTypeItem {
    Id: number | string;
    ExternalId: string;
    [key: string]: any;
}

export const useSecurityTypeIndex = (loadInitially: boolean = true) => {
    const { i18n } = useTranslation();

    const {
        data, isLoading, error, refetch,
    } = useGetCustomService({
        service: 'commonService',
        api: 'getSecurityTypes',
        payload: i18n.language,
        enabled: loadInitially,
    });

    const typeId = useMemo(() => {
        const types = data?.data as SecurityTypeItem[] | undefined;
        const typeIndex = types?.find(({ ExternalId }) => ExternalId === 'Index');

        return typeIndex?.Id;
    }, [data]);

    return {
        typeId,
        isLoadingTypeId: isLoading,
        errorTypeId: error,
        getTypeIndexId: refetch,
    };
};
